'use strict';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var SqlString = require('sqlstring');
var debug = require('debug')('leoric');
var Logger = require('./logger');
var Attribute = require('./attribute');
var DataTypes = require('../../data_types');
var Spellbook = require('./spellbook');
var _a = require('../../utils/string'), heresql = _a.heresql, camelCase = _a.camelCase;
/**
 * Migration methods
 * - https://dev.mysql.com/doc/refman/8.0/en/create-table.html
 * - https://dev.mysql.com/doc/refman/8.0/en/alter-table.html
 */
var AbstractDriver = /** @class */ (function () {
    function AbstractDriver(opts) {
        if (opts === void 0) { opts = {}; }
        var logger = opts.logger;
        this.logger = logger instanceof Logger ? logger : new Logger(logger);
        this.idleTimeout = opts.idleTimeout || 60;
        this.options = opts;
        this.Attribute = this.constructor.Attribute;
        this.DataTypes = this.constructor.DataTypes;
        this.spellbook = new this.constructor.Spellbook();
        this.escape = SqlString.escape;
        this.escapeId = SqlString.escapeId;
    }
    /**
     * query with spell
     * @param {Spell} spell
     * @returns
     */
    AbstractDriver.prototype.cast = function (spell) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, sql, values, query;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.format(spell), sql = _a.sql, values = _a.values;
                        query = { sql: sql, nestTables: spell.command === 'select' };
                        return [4 /*yield*/, this.query(query, values, spell)];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    /**
     * raw query
     * @param {object|string} query
     * @param {object | array} values
     * @param {object} opts
     */
    AbstractDriver.prototype.query = function (query, values, opts) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error('unimplemented!');
            });
        });
    };
    /**
     * disconnect manually
     * @param {Function} callback
     */
    AbstractDriver.prototype.disconnect = function (callback) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                debug('[disconnect] called');
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(AbstractDriver.prototype, "dialect", {
        get: function () {
            return camelCase(this.constructor.name.replace('Driver', ''));
        },
        enumerable: false,
        configurable: true
    });
    /**
     * use spellbook to format spell
     * @param {Spell} spell
     * @returns
     */
    AbstractDriver.prototype.format = function (spell) {
        return this.spellbook.format(spell);
    };
    AbstractDriver.prototype.createTable = function (table, attributes) {
        return __awaiter(this, void 0, void 0, function () {
            var escapeId, chunks, columns;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        escapeId = this.escapeId;
                        chunks = ["CREATE TABLE ".concat(escapeId(table))];
                        columns = Object.keys(attributes).map(function (name) {
                            var attribute = new _this.Attribute(name, attributes[name]);
                            return attribute.toSqlString();
                        });
                        chunks.push("(".concat(columns.join(', '), ")"));
                        return [4 /*yield*/, this.query(chunks.join(' '))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AbstractDriver.prototype.alterTable = function (table, attributes) {
        return __awaiter(this, void 0, void 0, function () {
            var escapeId, chunks, actions;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        escapeId = this.escapeId;
                        chunks = ["ALTER TABLE ".concat(escapeId(table))];
                        actions = Object.keys(attributes).map(function (name) {
                            var options = attributes[name];
                            // { [columnName]: { remove: true } }
                            if (options.remove)
                                return "DROP COLUMN ".concat(escapeId(name));
                            var attribute = new _this.Attribute(name, options);
                            return [
                                options.modify ? 'MODIFY COLUMN' : 'ADD COLUMN',
                                attribute.toSqlString(),
                            ].join(' ');
                        });
                        chunks.push(actions.join(', '));
                        return [4 /*yield*/, this.query(chunks.join(' '))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AbstractDriver.prototype.describeTable = function (table) {
        return __awaiter(this, void 0, void 0, function () {
            var database, schemaInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        database = this.options.database;
                        return [4 /*yield*/, this.querySchemaInfo(database, table)];
                    case 1:
                        schemaInfo = _a.sent();
                        return [2 /*return*/, schemaInfo[table].reduce(function (result, column) {
                                result[column.columnName] = column;
                                return result;
                            }, {})];
                }
            });
        });
    };
    AbstractDriver.prototype.addColumn = function (table, name, params) {
        return __awaiter(this, void 0, void 0, function () {
            var escapeId, attribute, sql;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        escapeId = this.escapeId;
                        attribute = new this.Attribute(name, params);
                        sql = heresql("\n      ALTER TABLE ".concat(escapeId(table), "\n      ADD COLUMN ").concat(attribute.toSqlString(), "\n    "));
                        return [4 /*yield*/, this.query(sql)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AbstractDriver.prototype.changeColumn = function (table, name, params) {
        return __awaiter(this, void 0, void 0, function () {
            var escapeId, attribute, sql;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        escapeId = this.escapeId;
                        attribute = new this.Attribute(name, params);
                        sql = heresql("\n      ALTER TABLE ".concat(escapeId(table), "\n      MODIFY COLUMN ").concat(attribute.toSqlString(), "\n    "));
                        return [4 /*yield*/, this.query(sql)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AbstractDriver.prototype.removeColumn = function (table, name) {
        return __awaiter(this, void 0, void 0, function () {
            var escapeId, columnName, sql;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        escapeId = this.escapeId;
                        columnName = new this.Attribute(name).columnName;
                        sql = heresql("\n      ALTER TABLE ".concat(escapeId(table), " DROP COLUMN ").concat(escapeId(columnName), "\n    "));
                        return [4 /*yield*/, this.query(sql)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AbstractDriver.prototype.renameColumn = function (table, name, newName) {
        return __awaiter(this, void 0, void 0, function () {
            var escapeId, columnName, attribute, sql;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        escapeId = this.escapeId;
                        columnName = new this.Attribute(name).columnName;
                        attribute = new this.Attribute(newName);
                        sql = heresql("\n      ALTER TABLE ".concat(escapeId(table), "\n      RENAME COLUMN ").concat(escapeId(columnName), " TO ").concat(escapeId(attribute.columnName), "\n    "));
                        return [4 /*yield*/, this.query(sql)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AbstractDriver.prototype.renameTable = function (table, newTable) {
        return __awaiter(this, void 0, void 0, function () {
            var escapeId, sql;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        escapeId = this.escapeId;
                        sql = heresql("\n      ALTER TABLE ".concat(escapeId(table), " RENAME TO ").concat(escapeId(newTable), "\n    "));
                        return [4 /*yield*/, this.query(sql)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AbstractDriver.prototype.dropTable = function (table) {
        return __awaiter(this, void 0, void 0, function () {
            var escapeId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        escapeId = this.escapeId;
                        return [4 /*yield*/, this.query("DROP TABLE IF EXISTS ".concat(escapeId(table)))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AbstractDriver.prototype.truncateTable = function (table) {
        return __awaiter(this, void 0, void 0, function () {
            var escapeId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        escapeId = this.escapeId;
                        return [4 /*yield*/, this.query("TRUNCATE TABLE ".concat(escapeId(table)))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AbstractDriver.prototype.addIndex = function (table, attributes, opts) {
        if (opts === void 0) { opts = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var escapeId, columns, type, prefix, name, sql;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        escapeId = this.escapeId;
                        columns = attributes.map(function (name) { return new _this.Attribute(name).columnName; });
                        type = opts.unique ? 'UNIQUE' : opts.type;
                        prefix = type === 'UNIQUE' ? 'uk' : 'idx';
                        name = __assign({ name: [prefix, table].concat(columns).join('_') }, opts).name;
                        if (type != null && !['UNIQUE', 'FULLTEXT', 'SPATIAL'].includes(type)) {
                            throw new Error("Unexpected index type: ".concat(type));
                        }
                        sql = heresql("\n      CREATE ".concat(type ? "".concat(type, " INDEX") : 'INDEX', " ").concat(escapeId(name), "\n      ON ").concat(escapeId(table), " (").concat(columns.map(escapeId).join(', '), ")\n    "));
                        return [4 /*yield*/, this.query(sql)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AbstractDriver.prototype.removeIndex = function (table, attributes, opts) {
        if (opts === void 0) { opts = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var escapeId, name, columns, type, prefix, sql;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        escapeId = this.escapeId;
                        if (Array.isArray(attributes)) {
                            columns = attributes.map(function (entry) { return new _this.Attribute(entry).columnName; });
                            type = opts.unique ? 'UNIQUE' : opts.type;
                            prefix = type === 'UNIQUE' ? 'uk' : 'idx';
                            name = [prefix, table].concat(columns).join('_');
                        }
                        else if (typeof attributes === 'string') {
                            name = attributes;
                        }
                        else {
                            throw new Error("Unexpected index name: ".concat(attributes));
                        }
                        sql = this.type === 'mysql'
                            ? "DROP INDEX ".concat(escapeId(name), " ON ").concat(escapeId(table))
                            : "DROP INDEX IF EXISTS ".concat(escapeId(name));
                        return [4 /*yield*/, this.query(sql)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AbstractDriver.prototype.rollback = function (opts) {
        return __awaiter(this, void 0, void 0, function () {
            var connection, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = opts.connection;
                        if (_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getConnection()];
                    case 1:
                        _a = (_b.sent());
                        _b.label = 2;
                    case 2:
                        connection = _a;
                        return [4 /*yield*/, this.query('ROLLBACK', [], __assign(__assign({ command: 'ROLLBACK' }, opts), { connection: connection }))];
                    case 3: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    AbstractDriver.prototype.commit = function (opts) {
        return __awaiter(this, void 0, void 0, function () {
            var connection, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = opts.connection;
                        if (_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getConnection()];
                    case 1:
                        _a = (_b.sent());
                        _b.label = 2;
                    case 2:
                        connection = _a;
                        return [4 /*yield*/, this.query('COMMIT', [], __assign(__assign({ command: 'COMMIT' }, opts), { connection: connection }))];
                    case 3: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    AbstractDriver.prototype.begin = function (opts) {
        return __awaiter(this, void 0, void 0, function () {
            var connection, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = opts.connection;
                        if (_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getConnection()];
                    case 1:
                        _a = (_b.sent());
                        _b.label = 2;
                    case 2:
                        connection = _a;
                        return [4 /*yield*/, this.query('BEGIN', [], __assign(__assign({ command: 'BEGIN' }, opts), { connection: connection }))];
                    case 3: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    // define static properties as this way IDE will prompt
    AbstractDriver.Spellbook = Spellbook;
    AbstractDriver.Attribute = Attribute;
    AbstractDriver.DataTypes = DataTypes;
    return AbstractDriver;
}());
;
module.exports = AbstractDriver;
//# sourceMappingURL=index.js.map